(function () {
  'use strict';

  function buildMapEmbedUrl(query) {
    if (!query) return '';
    return 'https://www.google.com/maps?q=' + encodeURIComponent(query) + '&output=embed';
  }

  function selectStore(storeEl, panel) {
    if (!panel) return;

    var stores = panel.querySelectorAll('[data-store-locator-store]');
    stores.forEach(function (store) {
      var isActive = store === storeEl;
      store.classList.toggle('is-active', isActive);
      store.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    var iframe = panel.querySelector('[data-store-locator-map]');
    if (!iframe || !storeEl) return;

    var query = storeEl.dataset.mapQuery;
    if (!query) return;

    var nextSrc = buildMapEmbedUrl(query);
    if (iframe.getAttribute('src') !== nextSrc) {
      iframe.setAttribute('src', nextSrc);
    }
  }

  function activateFirstStore(panel) {
    if (!panel) return;
    var firstStore = panel.querySelector('[data-store-locator-store]');
    if (firstStore) {
      selectStore(firstStore, panel);
    }
  }

  function initStoreLocator(root) {
    if (!root || root.dataset.storeLocatorBound === 'true') return;
    root.dataset.storeLocatorBound = 'true';

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-store-locator-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-store-locator-panel]'));
    if (!tabs.length || !panels.length) return;

    function activate(cityKey) {
      tabs.forEach(function (tab) {
        var isActive = tab.dataset.storeLocatorTab === cityKey;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tab.tabIndex = isActive ? 0 : -1;
      });

      var activePanel = null;

      panels.forEach(function (panel) {
        var isActive = panel.dataset.storeLocatorPanel === cityKey;
        panel.classList.toggle('is-active', isActive);
        panel.hidden = !isActive;
        if (isActive) activePanel = panel;
      });

      activateFirstStore(activePanel);
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activate(tab.dataset.storeLocatorTab);
      });

      tab.addEventListener('keydown', function (event) {
        var index = tabs.indexOf(tab);
        var nextIndex = index;

        if (event.key === 'ArrowRight') {
          nextIndex = (index + 1) % tabs.length;
        } else if (event.key === 'ArrowLeft') {
          nextIndex = (index - 1 + tabs.length) % tabs.length;
        } else {
          return;
        }

        event.preventDefault();
        tabs[nextIndex].focus();
        activate(tabs[nextIndex].dataset.storeLocatorTab);
      });
    });

    panels.forEach(function (panel) {
      panel.addEventListener('click', function (event) {
        var storeEl = event.target.closest('[data-store-locator-store]');
        if (!storeEl || !panel.contains(storeEl)) return;
        if (event.target.closest('a')) return;
        selectStore(storeEl, panel);
      });

      panel.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;

        var storeEl = event.target.closest('[data-store-locator-store]');
        if (!storeEl || !panel.contains(storeEl)) return;

        event.preventDefault();
        selectStore(storeEl, panel);
      });
    });

    var initialTab = tabs.find(function (tab) {
      return tab.classList.contains('is-active');
    });

    activate(initialTab ? initialTab.dataset.storeLocatorTab : tabs[0].dataset.storeLocatorTab);
  }

  function initAll() {
    document.querySelectorAll('[data-store-locator]').forEach(initStoreLocator);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
